import parentApi from './axios/studentAxios';

export const getStudentClassesRequest = (studentId) => parentApi.get(`/students/${studentId}/classes`);
